import { getJobIdentifier } from '@/shared/utils/job-helpers';
import { truncate, initialsOfName, formatCnpj } from '@/shared/utils/helpers';

const filters = [
  {
    name: 'capitalize',
    execute: (str) => str.charAt(0).toUpperCase() + str.slice(1),
  },
  {
    name: 'emptyValueTable',
    execute: (str) => (str && str.length > 0 ? str : '-'),
  },
  {
    name: 'jobIdentifierByChannel',
    execute: (job) => {
      return getJobIdentifier(job);
    },
  },
  {
    name: 'iconByChannel',
    execute: (channel) => {
      const icons = {
        whatsapp: 'mdi-whatsapp',
        voice: 'mdi-phone',
        chat: 'mdi-message-text-outline',
        instagram: 'mdi-instagram',
      };
      return icons[channel.toLowerCase()];
    },
  },
  {
    name: 'firstWord',
    execute: (text) => text.replace(/ .*/, ''),
  },
  {
    name: 'queueInformation',
    execute: (job) => {
      if (job.channel === 'voice')
        return job.activeAttendance ? job.campaign.name : job.queue.queue_name;

      return job.activeAttendance ? job.campaign.context : job.queue.name;
    },
  },
  {
    name: 'truncate',
    execute: truncate,
  },
  {
    name: 'initialsOfName',
    execute: initialsOfName,
  },
  {
    name: 'formatCnpj',
    execute: formatCnpj,
  },
];

export default filters;
